import { CommonModule } from '@angular/common';
import { AppComponent } from '../app.component';
import { ComponentsRouteModule } from './components-routing.module';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { DashboardModule } from './dashboard/dashboard.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { NgxMaskPipe } from 'ngx-mask';
import { HomeModule } from './home/home.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { TableTransactionsComponent } from './table-transactions/table-transactions.component';
import { TableTransactionsReservaComponent } from './table-transactions-reserva/table-transactions-reserva.component';
import { TableTransactionsCommissionsComponent } from './table-transactions-commissions/table-transactions-commissions.component';
import { TableSummaryComponent } from './table-summary/table-summary.component';
import { TableSubAccountsComponent } from './table-sub-accounts/table-sub-accounts.component';
import { FormsModule } from '@angular/forms';
import { TableInfractionsComponent } from './table-infractions/table-infractions.component';
import { TableCommissionsWalletComponent } from './table-commissions-wallet/table-commissions-wallet.component';
import { TableApiCredentials } from './table-api-credentials/table-api-credentials.component';
import { TableTransactionalAccountsComponent } from './table-transactional-accounts/table-transactional-accounts.component';
import { TablePlayerListComponent } from './table-player-list/table-player-list.component';
import { TableActivityLogComponent } from './table-activity-log/table-activity-log.component';
import { TableTechnicalEventsComponent } from './table-technical-events/table-technical-events.component';
import { TableOperatorsComponent } from './table-operators/table-operators.component';
import { TableFinancialSummaryComponent } from './table-financial-summary/table-financial-summary.component';
import { TableBetSummaryComponent } from './table-bet-summary/table-bet-summary.component';
import { TableOperatorListComponent } from './table-operator-list/table-operator-list.component';
import { QrCodeComponent } from './qr-code/qr-code.component';

@NgModule({
  declarations: [
    TableTransactionsComponent,
    TableTransactionsReservaComponent,
    TableTransactionsCommissionsComponent,
    TableSummaryComponent,
    TableInfractionsComponent,
    TableSubAccountsComponent,
    TableCommissionsWalletComponent,
    TableApiCredentials,
    TableTransactionalAccountsComponent,
    TablePlayerListComponent,
    TableActivityLogComponent,
    TableTechnicalEventsComponent,
    TableOperatorsComponent,
    TableFinancialSummaryComponent,
    TableBetSummaryComponent,
    TableOperatorListComponent,
    QrCodeComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    NgbModule,
    ComponentsRouteModule,
    MatPaginatorModule,
    MatTableModule,
    NgxMaskPipe,
    HomeModule,
    DashboardModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
  ],
  providers: [],
  exports: [
    TableTransactionsComponent,
    TableTransactionsReservaComponent,
    TableTransactionsCommissionsComponent,
    TableSummaryComponent,
    TableInfractionsComponent,
    TableSubAccountsComponent,
    TableCommissionsWalletComponent,
    TableApiCredentials,
    TableTransactionalAccountsComponent,
    TablePlayerListComponent,
    TableActivityLogComponent,
    TableTechnicalEventsComponent,
    TableOperatorsComponent,
    TableFinancialSummaryComponent,
    TableBetSummaryComponent,
    TableOperatorListComponent,
    QrCodeComponent,
  ],
  bootstrap: [AppComponent],
})
export class ComponentsModule {}
